import React, { useEffect, useState } from 'react';
import { useDrop } from 'react-dnd';
import ReactDOM from 'react-dom';
import { injectIntl, FormattedMessage } from 'react-intl';
import { i18nIntl, isDesktop } from '../../lib/ep.js';

import ActionButton from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';
import CartSortable from '../builder/CartSortable.js';
import DisabledArea from '../builder/DisabledArea.js';
import ToggleButton from '../builder/ToggleButton.js';

import SingleGallery from '../front/SingleGallery.js';

function calculateWideScreen() {
	return (parseInt(window.innerWidth) > 800) ? true : false;
}

const ConfirmVotesButton = ({ submitVote, enable_confirm_votes, is_logged, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const avail_participations = (props.avail_participations != undefined) ? props.avail_participations : {};
	const has_more_participations = (avail_participations.retries == undefined || avail_participations.retries > 0) ? true : false;
	let next_participation = (avail_participations.next_participation != undefined) ? avail_participations.next_participation : false;
	if (avail_participations.next_participation_notz != undefined) next_participation = avail_participations.next_participation_notz;
	if(!has_more_participations && next_participation !== false) {
		return (
			<div class="cta_buttons solid_buttons future_access redBg">
				<p class="whiteColor"><FormattedMessage id="You'll be able to save the votes {next}" values={{next:<strong>{moment.tz(next_participation, props.tz).fromNow()}</strong>}} /></p>
			</div>
		)
	}

	if(props.display_message_vote_self) {
		return (
			<div class="cta_buttons solid_buttons future_access redBg">
				<p class="whiteColor">{i18n("You cannot vote for one of your entries. Remove the vote to continue.")}</p>
			</div>
		)
	}

	const goToLogin = () => {
		window.location.href = '/login/'+props.promotion.id;
	}

	const button_label = (is_logged) ? "Confirm votes" : "Continue";

	const submitAction = is_logged ? submitVote : goToLogin;

	return (
		<div class={'cta_buttons solid_buttons' + ((!enable_confirm_votes && is_logged) ? ' gui_remove_pointer_events' : '')}>
			<DisabledArea classname="flex_button gui_actions" disabled={!enable_confirm_votes && is_logged} tooltip_position="bottom">
				<ActionButton
					_fullclass="confirm_votes_button in_top"
					onClick={submitAction}
				>{button_label}</ActionButton>
			</DisabledArea>

			{(!is_logged && calculateWideScreen()) && (
				<p class="extra_msg">{i18n("Next step: sign in")}</p>
			)}
		</div>
	);
};

const Tier = ({ item, ...props }) => {
	const [, drop] = useDrop(() => ({
		accept:'GALLERY',
		drop:(item, monitor) => {
			props.onItemDrop(item, props.index);
		}
	}), [props.index]);

	const editing_votes = (props.editing_votes != undefined) ? props.editing_votes : false;

	if(item != false) {
		return (
			<SingleGallery
				is_in_cart={true}
				media_index={0}
				promotion={props.promotion}
				selected_entry={false}
				stage={{}}
				user={item}
				removeFromCart={(editing_votes) ? (item) => props.removeFromCart(item, props.index) : null}
			/>
		)
	}

	const gallery_proportion = props.stage?.gallery_proportion ?? '15x12';

	return (
		<li class="user_to_vote pending" ref={drop}>
			<div class="photo_embed">
				<img src={`${window.cdn_url}img/blank_${gallery_proportion}.png`} width="100%" alt="" />
			</div>
		</li>
	);
};

const EntriesVotingCart = ({ users, stage, collapsed, toggleCollapsed, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const is_builder = (props.is_builder != undefined) ? props.is_builder : false;
	const is_logged = (props.is_logged != undefined) ? props.is_logged : false;
	const login_id = (props.login_id != undefined) ? props.login_id : false;
	const avail_participations = (props.avail_participations != undefined) ? props.avail_participations : {};

	const [is_wide_screen, setIsWideScreen] = useState(calculateWideScreen());
	const [editing_votes, setEditingVotes] = useState(true);

	useEffect(() => {
		detectIfWideScreen();
		window.addEventListener('resize', detectIfWideScreen);

		return () => {
			window.removeEventListener('resize', detectIfWideScreen);
		}
	}, []);

	const detectIfWideScreen = () => {
		setIsWideScreen(calculateWideScreen());
	};

	const submitVote = () => {
		if(is_builder) return;

		let vote_info = [];
		for(var i in users) {
			if(!users[i]) continue;
			if(stage.voting_type == 'tiered' || stage.voting_type == 'ponderated') {
				let tier = stage.voting_tiers[i];
				vote_info.push({ id:users[i].StageVote.id, tier:tier.id, score:tier.tier_score });
			} else {
				vote_info.push({ id:users[i].StageVote.id, score:1 });
			}
		}

		props.votingSubmit(0, { quiz_entry:{ votes:vote_info } }, (response) => {
			setTimeout(() => {
				if(props.dispatchGallery != undefined) {
					props.dispatchGallery({ type:'SET_RESPONSE', response });
				} else {
	//				window.location.href = response.url;
				}
			}, 1500);
		});
	};

	const removeFromCart = (_user, index) => {
		if(props.removeFromCart != undefined) props.removeFromCart(_user.Participation.id,index);
	};

	const onChange = (items) => {
		props.onSortEnd(items);
	};

	const getCastedVotes = () => {
		return users.filter((obj) => { return obj !== false; }).length;
	};

	if(users.length == 0 || (stage.voting_type != 'simple' && (stage.voting_tiers == undefined || stage.voting_tiers.length == 0))) return null;
	let cart_classes = ['voting_cart', 'gui_main_text_color_on_bg'];
	if(is_builder) cart_classes.push('awesome');

	const element_id = (!is_builder) ? 'ep_main_container' : 'layout_in_builder_container';
	if(document.getElementById(element_id) == null) return null;

	let actual_votes = getCastedVotes();
	let max_votes = 0;
	let enable_confirm_votes = false;
	let display_sorting = false;
	switch(stage.voting_type) {
		case 'simple':
			max_votes = parseInt((stage.voting_max != undefined) ? stage.voting_max : 3);
			let min_votes = parseInt((stage.voting_min != undefined) ? stage.voting_min : 1);
			enable_confirm_votes = (actual_votes >= min_votes) ? true : false;
			break;

		case 'tiered':
		case 'ponderated':
		default:
			max_votes = stage.voting_tiers != undefined ? stage.voting_tiers.length : 0;
			enable_confirm_votes = (actual_votes >= max_votes) ? true : false;
			display_sorting = true;
			break;
	}

	const display_on_side = (isDesktop() && is_wide_screen) ? true : false;

	const promo_container = document.querySelector('.template_display');
	//const promo_container = document.querySelector('.template_contents');

	let display_message_vote_self = false;
	if(is_logged && stage.voting_self_unallowed == true){

		if(users.length>0) {
			for(var i in users) {
				if(!users[i]) continue;
				if(users[i].Participation.login_id == login_id){
					display_message_vote_self = true;
					enable_confirm_votes = false;
					break;
				}
			}
		}
	}


	const button_props = {
		avail_participations:avail_participations,
		submitVote:submitVote,
		enable_confirm_votes:enable_confirm_votes,
		display_message_vote_self:display_message_vote_self,
		is_logged:(is_builder || is_logged),
		intl:props.intl,
		tz:props.promotion.timezone,
		promotion:props.promotion,
	}

	const is_desktop = (isDesktop()) ? true : false;

	if(display_on_side) {
		if(document.querySelector('.ep_global_contents').classList.contains('is_rtl')) {
			promo_container.style.paddingLeft = '180px';
		} else {
			promo_container.style.paddingRight = '180px';
		}
		promo_container.style.paddingTop = '0';
		cart_classes.push('on_side');

		return ReactDOM.createPortal(
			<aside id="voting_cart" class={cart_classes.join(" ")}>
				<div class="cart_header">
					<div class="total_with_actions">
						{i18n("Your votes")}: <strong>{actual_votes}/{max_votes}</strong>

						{(display_sorting) && (
							<span> (<ActionLink onClick={() => setEditingVotes(!editing_votes)} autotranslate={false}>{i18n(((editing_votes) ? "Sort" : "Edit"), 'lowercase')}</ActionLink>)</span>
						)}
					</div>
				</div>

				<CartSortable
					items={users}
					tiers={stage.voting_tiers}
					onChange={onChange}
					stage={stage}
					editing_votes={editing_votes}
				>
					<Tier
						removeFromCart={removeFromCart}
						onItemDrop={props.onItemDrop}
						promotion={props.promotion}
						editing_votes={editing_votes}
						stage={stage}
					/>
				</CartSortable>

				<ConfirmVotesButton {...button_props} />
			</aside>,
			document.getElementById(element_id),
		);
	} else {
		cart_classes.push((is_desktop) ? 'on_top' : 'on_bottom');
	}

	if(collapsed) cart_classes.push('is_collapsed');
	promo_container.style.paddingRight = '0';
	if(is_desktop) {
		promo_container.style.paddingTop = '64px';
	} else {
		promo_container.style.paddingBottom = '64px';
	}

	return ReactDOM.createPortal(
		<aside id="voting_cart" class={cart_classes.join(" ")}>
			<div class="cart_header">
				<div class="total_with_actions">
					<ToggleButton squared={true} active={(collapsed) ? true : false} _class={{icon:'knk-arrow-b-big', icon_off:'knk-arrow-t-big', other:'expand_toggle_button'}} onClick={toggleCollapsed} />

					{i18n("Your votes")}: <strong>{actual_votes}/{max_votes}</strong>

					{(display_sorting && !collapsed) && (
						<span> (<ActionLink onClick={() => setEditingVotes(!editing_votes)} autotranslate={false}>{i18n(((editing_votes) ? "Sort" : "Edit"), 'lowercase')}</ActionLink>)</span>
					)}
				</div>

				<ConfirmVotesButton {...button_props} />
			</div>

			<CartSortable
				items={users}
				tiers={stage.voting_tiers}
				onChange={onChange}
				stage={stage}
				sort_axis="x"
				editing_votes={editing_votes}
			>
				<Tier
					removeFromCart={removeFromCart}
					onItemDrop={props.onItemDrop}
					promotion={props.promotion}
					editing_votes={editing_votes}
					stage={stage}
				/>
			</CartSortable>
		</aside>,
		document.getElementById(element_id),
	);
}

export default injectIntl(EntriesVotingCart);